import {
  BodyText,
  Box,
  Button,
  Flex,
  Strong,
  ValidationText,
} from '@utilitywarehouse/hearth-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { paths } from '@constants/paths';

import { SHARE_URL } from '../constants';
import { InviteValues } from './InviteValues';
import './styles.scss';

interface InviteProps {
  code: string;
  canStart: boolean;
  personLabel: string;
  isRemoteSupport: boolean;
  errorMessage: string;
}

const Invite = ({
  code,
  canStart,
  personLabel,
  isRemoteSupport,
  errorMessage,
}: InviteProps) => {
  const navigate = useNavigate();
  const [hasTriedStart, setHasTriedStart] = useState(false);

  const handleStartPresentation = () => {
    if (!canStart) {
      setHasTriedStart(true);
      return;
    }
    navigate(paths.presentation);
  };

  const error = !canStart && hasTriedStart ? errorMessage : '';

  return (
    <div className="wrapper">
      <div className="invite__Container">
        <Box className="invite__InstructionsList">
          <li className="invite__InstructionsListItem">
            <Strong>Call your {personLabel}</Strong>
          </li>
          <li className="invite__InstructionsListItem">
            <Strong>
              Share your appointment {isRemoteSupport ? 'code' : 'details'}
            </Strong>
            {!isRemoteSupport && (
              <BodyText>
                Ask your {personLabel} to visit <b>{SHARE_URL}</b> and enter
                your appointment code below. You can also share this code with
                your supporting partner.
              </BodyText>
            )}
            <InviteValues
              code={code}
              personLabel={personLabel}
              isRemoteSupport={isRemoteSupport}
            />
          </li>

          <li className="invite__InstructionsListItem">
            <Strong>Start appointment presentation</Strong>
            <BodyText>
              You’ll be able to start the presentation once your {personLabel}{' '}
              has joined.
            </BodyText>
          </li>
        </Box>
        <Flex direction="column" spacing="md">
          <Flex
            direction={{
              desktop: 'row',
              mobile: 'column',
            }}
          >
            <Button onClick={handleStartPresentation}>
              Start presentation
            </Button>
          </Flex>
          {error && <ValidationText status="invalid">{error}</ValidationText>}
        </Flex>
      </div>
    </div>
  );
};

export { Invite };
